export const roundToDecimals = (value: number, decimals: number): number => {
	const factor = 10 ** decimals; // 10 raised to the number of decimals
	return Math.round(value * factor) / factor;
};

export const roundDecimalsNoZeros = (num: number, decimalPlaces: number = 2) => {
	return num.toFixed(decimalPlaces).replace(/\.?0+$/, '');
};

// Number('') and Number(null) both return 0, which collapses an empty input into
// a $0 price. parsePriceAmount preserves "empty" as NaN so callers can tell a
// blank cell apart from a deliberate zero (e.g. user-scoped default pricing,
// where blank means "fall back to standard pricing").
export const parsePriceAmount = (value: unknown): number => {
	if (value === '' || value === null || value === undefined) return NaN;
	return Number(value);
};
